var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"hero custom-color"},[_c('div',{staticClass:"hero-body"},[_c('p',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('p',{staticClass:"subtitle",on:{"click":_vm.ejecutarFuncion}},[_vm._v(" "+_vm._s(_vm.subtitulo)+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }